import hostname from "./config.host";
import { fetchWrapper } from "./fetch-wrapper";
const apiUrl: string = `${hostname}/aladdin_api/v1`;

function getDeepViewData(
  oauthTokenHeader: any,
  brandId: string,
  destination_table_id: number,
  start_date: string,
  end_date: string,
  website_shared_uid: string[],
) {
  const uidParams = website_shared_uid
    .map((uid) => `website_shared_uid=${encodeURIComponent(uid)}`)
    .join("&");
  return fetchWrapper.get(
    `${apiUrl}/data_collection/deep_view/?brand_id=${brandId}&destination_table_id=${destination_table_id}&start_date=${start_date}&end_date=${end_date}&${uidParams}`,
    oauthTokenHeader,
  );
}

function getCurrenciesInDeepView(oauthTokenHeader: any) {
  return fetchWrapper.get(`${apiUrl}/meta/currencies/`, oauthTokenHeader);
}

export const deepViewEndpoints = {
  getDeepViewData,
  getCurrenciesInDeepView,
};
